import mustache from 'mustache'

/**
 * TODO: turn the context into HTML attributes d-context-<key>
 * @param {Element} containerElement
 * @param {Object} item
 * @param {Object} options
 * @returns
 */
export function showItem (containerElement, item, options) {
  const renderedHtml = mustache.render(htmlTemplate, {
    item
  })

  containerElement.insertAdjacentHTML('beforeend', renderedHtml)
  const Element = containerElement.lastElementChild

  Element.update = function (updateOptions) {
    const thisElement = this
    if (updateOptions.statusText) {
      thisElement.querySelector('span.tag[d-element="status"]').textContent = updateOptions.statusText
    }

    if (updateOptions.statusClass) {
      thisElement.querySelector('span.tag[d-element="status"]').classList.forEach(function (className) {
        if (className.startsWith('is-')) {
          thisElement.classList.remove(className)
        }
      })
      thisElement.querySelector('span.tag[d-element="status"]').classList.add(`${updateOptions.statusClass}`)
    }
  }

  Element.addEventListener('click', async (clickEvent) => {
    if (options.onClick) {
      await options.onClick(Element, clickEvent)
    }
  })

  return {
    Element
  }
}

const htmlTemplate = `
  <div class="control">
    <div class="tags has-addons">
      <span class="tag is-light button" d-element="label">{{item.label}}</span>
      <span class="tag is-dark" d-element="status">{{item.status}}</span>
    </div>
  </div>
  `
